import { PostStatusType } from '../types/post';

/**
 * Map of uppercase status keys to their display values.
 * Used for consistent post status lookups across the application.
 */
export const POST_STATUSES: Record<string, PostStatusType> = Object.freeze({
  DRAFT: 'draft',
  PUBLISHED: 'published',
  PRIVATE: 'private',
  SCHEDULED: 'scheduled',
  PENDING: 'pending',
  PITCH: 'pitch',
} as const);
